import { useState } from "react";

export const useCountrySelection = () => {
  const [selectedCountries, setSelectedCountries] = useState<string[]>([]);

  const handleCountrySelect = (countryCode: string) => {
    console.log("Country selection changed:", countryCode);
    setSelectedCountries(prev => {
      if (prev.includes(countryCode)) {
        return prev.filter(code => code !== countryCode);
      }
      return [...prev, countryCode];
    });
  };

  const handleClearFilters = () => {
    console.log("Clearing country filters");
    setSelectedCountries([]);
  };

  return {
    selectedCountries,
    handleCountrySelect,
    handleClearFilters
  };
};